module.exports = __webpack_public_path__ + "static/img/who-we-are__large.2ba35db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/CompanyTour/img/primary/who-we-are__large.jpg
// module id = 40qb
// module chunks = 1